import { modificarPeriodosInventario } from "../infrastructure/supabase/inventarioPeriodo.repository.js";

export async function modificarInventarioUseCase({ periodoId, estado }) {
  if (!periodoId || !estado) {
    throw new Error(
      "[modificarInventarioUseCase] Parámetros inválidos: periodoId y estado son requeridos"
    );
  }

  const modificacion = await modificarPeriodosInventario({ periodoId, estado });

  if (!modificacion) {
    throw new Error(
      "[modificarInventarioUseCase] No se pudo modificar el periodo de inventario"
    );
  }

  return modificacion;
}